import { Route, redirect } from "react-router";
import type { PropsWithChildren } from "react";
import {
  getLanguageCookie,
  parseSupportedLanguageCode,
} from "./utils/language";
import { urlWithLanguageCode } from "./utils/url/urlWithLanguageCode";

export function AppRoutes({
  children,
  global,
}: PropsWithChildren<{ global?: React.ReactNode }>) {
  return (
    <Route>
      <Route
        path="/:languageCode?/map"
        element={global}
        loader={({ params, request }) => {
          const languageCodeCookie = getLanguageCookie();
          const languageCode =
            parseSupportedLanguageCode(params["languageCode"]) ?? "en";

          // If the cookie is set and does not match the URL, redirect to the correct language for the user.
          if (languageCodeCookie && languageCode !== languageCodeCookie) {
            const url = new URL(request.url);

            // react-router doesn't retain the hash, so we need to add it here.
            url.hash = window.location.hash;

            const currentPath = url.pathname;
            url.pathname = urlWithLanguageCode(currentPath, languageCodeCookie);

            return redirect(url.toString());
          }
        }}
      >
        <Route
          path=":originCanonical?/:destinationCanonical?"
          element={children}
        />
      </Route>
      <Route
        path="*"
        element={children}
        loader={() => {
          return redirect("/map");
        }}
      />
    </Route>
  );
}
